import { render, staticRenderFns } from "./PersonaEmailsView.vue?vue&type=template&id=4dfe6c34&scoped=true"
import script from "./PersonaEmailsView.vue?vue&type=script&lang=js"
export * from "./PersonaEmailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe6c34",
  null
  
)

export default component.exports